<template>
    <td>
        <el-switch v-model="data.auto_app_goals"/>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>